/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_DescriptionInputs */



/**
* | output |
* | --- |
* | "AI-powered monitoring and automatic escalation of sensitive interactions" |
*
* @param {Compliance_Copilot_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_description = /** @type {((inputs?: Compliance_Copilot_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-gestützte Überwachung und automatische Eskalation sensibler Interaktionen")
	return /** @type {LocalizedString} */ ("AI-powered monitoring and automatic escalation of sensitive interactions")
});